import {HttpClient, HttpHeaders} from '@angular/common/http';
import {PageEvent} from '@angular/material/paginator';
import {Sort} from '@angular/material/sort';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {Paginable} from '../components/welfy-table/model/paginable-interface';

export enum RequestMethod {
  GET,
  POST,
  DELETE,
}

export abstract class AbstractApiService<T> {
  abstract _endpoint: string;

  protected constructor(private http: HttpClient) {
  }

  get urlBase() {
    return environment.backendUrl;
  }

  protected sendRequest<T>(
    endPoint: string,
    method: RequestMethod,
    body?: any,
    useUploadHeader?: boolean,
    ignoreJson?: boolean
  ): Observable<T> {
    // build endpoint url
    endPoint = this.urlBase + endPoint;
    const data = ignoreJson ? body : JSON.stringify(body);

    switch (method) {
      case RequestMethod.GET: {
        return this.http.get<T>(endPoint, {
          headers: useUploadHeader
            ? this.buildUploadHeader()
            : this.buildRequestHeader(),
        });
      }
      case RequestMethod.POST: {
        return this.http.post<T>(endPoint, data, {
          headers: useUploadHeader
            ? this.buildUploadHeader()
            : this.buildRequestHeader(),
        });
      }
      case RequestMethod.DELETE: {
        return this.http.delete<T>(endPoint, {
          headers: useUploadHeader
            ? this.buildUploadHeader()
            : this.buildRequestHeader(),
        });
      }
    }
  }

  get endpoint() {
    return this._endpoint;
  }

  set endpoint(value){
    this._endpoint = value;
  }

  getPageRequest(sort?: Sort, page?: PageEvent, params?: Map<String, String>): Observable<Paginable<T>> {
    let pageIndex = 0;
    let pageSize = 10;
    if (page) {
      pageIndex = page.pageIndex;
      pageSize = page.pageSize;
    }

    return this.sendRequest(
      this.endpoint +
      '?size=' +
      pageSize +
      '&page=' +
      pageIndex +
      this.buildSortRequest(sort) + this.buildRequestParameter(params),
      RequestMethod.GET
    );
  }

  private buildRequestParameter(params: Map<String, String>) {
    let ret = '';
    if (params) {
      for (let [key, value] of params) {
        console.log(key, value);
        ret += '&' + key + '=' + value;
      }
    }
    return ret;
  }

  getObject(id: string): Observable<T> {
    return this.sendRequest<T>(this.endpoint + '?id=' + id, RequestMethod.GET);
  }

  getObjects(): Observable<Array<T>> {
    return this.sendRequest(this.endpoint, RequestMethod.GET);
  }

  save(value: T): Observable<T> {
    return this.sendRequest<T>(this.endpoint, RequestMethod.POST, value);
  }

  delete(id: string) {
    return this.sendRequest(this.endpoint + '?id=' + id, RequestMethod.DELETE);
  }

  search(
    value: string,
    sort?: Sort,
    page?: PageEvent
  ): Observable<Paginable<T>> {
    let pageIndex = 0;
    let pageSize = 10;
    if (page) {
      pageIndex = page.pageIndex;
      pageSize = page.pageSize;
    }
    return this.sendRequest<Paginable<T>>(
      this.endpoint +
      '/search?value=' +
      encodeURIComponent(value) +
      '&size=' +
      pageSize +
      '&page=' +
      pageIndex +
      this.buildSortRequest(sort),
      RequestMethod.GET
    );
  }

  private buildSortRequest(sort: Sort) {
    if (sort) {
      return '&sortBy=' + sort.active + '&sortDirection=' + sort.direction;
    }
    return '';
  }

  get RequestMethod() {
    return RequestMethod;
  }

  get authToken() {
    return localStorage.getItem('token');
  }

  private buildRequestHeader(): HttpHeaders {
    const token = this.authToken;

    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: token ? token : '',
      'Access-Control-Allow-Origin': '*',
    });
  }


  private buildUploadHeader(): HttpHeaders {
    const token = this.authToken;
    return new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      Authorization: token ? token : '',
    });
  }
}
